"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var nameSorter = function nameSorter(a, b) {
  return a.name.toLowerCase() < b.name.toLowerCase() ? -1 : a.name.toLowerCase() > b.name.toLowerCase() ? 1 : 0;
};

var amsProjectManagementWrapper = function amsProjectManagementWrapper(Component) {
  return function (_ref) {
    var _ref$groups = _ref.groups,
        groups = _ref$groups === void 0 ? [] : _ref$groups,
        project = _ref.project,
        users = _ref.users,
        children = _ref.children,
        getGroups = _ref.getGroups,
        getUsers = _ref.getUsers,
        getRequests = _ref.getRequests,
        props = _objectWithoutProperties(_ref, ["groups", "project", "users", "children", "getGroups", "getUsers", "getRequests"]);

    _react["default"].useEffect(function () {
      getGroups();
      getUsers();
      getRequests();
    }, [getGroups, getUsers, getRequests]);

    var _React$useMemo = _react["default"].useMemo(function () {
      return groups.reduce(function (a, c) {
        var authLevel = c.projects.reduce(function (a, c) {
          return c.project_name === project ? +c.auth_level : a;
        }, -1);

        if (authLevel > -1) {
          c.authLevel = authLevel;
          a[0].push(c);
        } else {
          a[1].push(c);
        }

        return a;
      }, [[], []]);
    }, [groups, project]),
        _React$useMemo2 = _slicedToArray(_React$useMemo, 2),
        groupsInProject = _React$useMemo2[0],
        otherGroups = _React$useMemo2[1];

    groupsInProject.sort(nameSorter);
    otherGroups.sort(nameSorter);

    var _React$useMemo3 = _react["default"].useMemo(function () {
      return users.reduce(function (a, c) {
        if (c.projects.reduce(function (a, c) {
          return a || c.project_name === project;
        }, false)) {
          a[0].push(c);
        } else {
          a[1].push(c);
        }

        return a;
      }, [[], []]);
    }, [users, project]),
        _React$useMemo4 = _slicedToArray(_React$useMemo3, 2),
        usersInProject = _React$useMemo4[0],
        otherUsers = _React$useMemo4[1];

    return /*#__PURE__*/_react["default"].createElement(Component, _extends({}, props, {
      project: project,
      getGroups: getGroups,
      getUsers: getUsers,
      getRequests: getRequests,
      users: usersInProject,
      otherUsers: otherUsers,
      groups: groupsInProject,
      otherGroups: otherGroups
    }), _react["default"].Children.toArray(children).map(function (child) {
      return /*#__PURE__*/_react["default"].cloneElement(child, _objectSpread(_objectSpread({}, props), {}, {
        project: project,
        getGroups: getGroups,
        getUsers: getUsers,
        getRequests: getRequests,
        users: usersInProject,
        otherUsers: otherUsers,
        groups: groupsInProject,
        otherGroups: otherGroups
      }));
    }));
  };
};

var _default = amsProjectManagementWrapper;
exports["default"] = _default;